import * as stylex from "@stylexjs/stylex";
import {
  colors,
  fonts,
  fontSizes,
  radii,
  spacing,
} from "@softmax/design-system/tokens.stylex";
import { Fragment } from "react";

import type { StoreDetailRow } from "./store-detail-rows";

export function StoreDetailsFacts({
  rows,
  tags,
  sentenceCaseLabel = false,
}: {
  readonly rows: readonly StoreDetailRow[];
  readonly tags: readonly string[];
  readonly sentenceCaseLabel?: boolean;
}) {
  return (
    <div {...stylex.props(styles.block)}>
      {rows.length ? (
        <dl {...stylex.props(styles.facts)}>
          {rows.map((row) => (
            <Fragment key={row.key}>
              <dt
                {...stylex.props(
                  styles.label,
                  !sentenceCaseLabel && styles.uppercase,
                )}
              >
                {row.label}
              </dt>
              <dd {...stylex.props(styles.value)}>{row.value}</dd>
            </Fragment>
          ))}
        </dl>
      ) : null}
      {tags.length ? (
        <ul {...stylex.props(styles.tags)}>
          {tags.map((tag) => (
            <li key={tag} {...stylex.props(styles.tag)}>
              {tag}
            </li>
          ))}
        </ul>
      ) : null}
    </div>
  );
}

const styles = stylex.create({
  block: { display: "flex", flexDirection: "column", gap: spacing.space12 },
  facts: {
    display: "grid",
    margin: 0,
    gridTemplateColumns: "96px minmax(0, 1fr)",
    columnGap: spacing.space12,
    rowGap: spacing.space6,
  },
  label: {
    fontFamily: fonts.mono,
    fontSize: 11,
    lineHeight: "18px",
    letterSpacing: "0.06em",
    color: colors.subtle,
  },
  uppercase: { textTransform: "uppercase" },
  value: {
    margin: 0,
    fontFamily: fonts.mono,
    fontSize: fontSizes.small,
    lineHeight: "18px",
    color: colors.foreground,
  },
  tags: {
    display: "flex",
    flexWrap: "wrap",
    gap: spacing.space8,
    listStyle: "none",
    margin: 0,
    padding: 0,
  },
  tag: {
    borderWidth: 1,
    borderStyle: "solid",
    borderColor: colors.borderStrong,
    borderRadius: radii.small,
    backgroundColor: colors.background,
    paddingInline: spacing.space8,
    paddingBlock: 3,
    fontFamily: fonts.mono,
    fontSize: fontSizes.caption,
    lineHeight: "18px",
    color: colors.foreground,
  },
});
